<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检任务" prop="taskId">
              <j-dict-select-tag dictCode placeholder="请选择巡检任务" type="list" v-model="model.taskId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域" prop="devProcessId">
              <j-dict-select-tag dictCode placeholder="请选择供水流域" type="list" v-model="model.devProcessId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检点" prop="patrolPointId">
              <j-dict-select-tag dictCode placeholder="请选择巡检点" type="list" v-model="model.patrolPointId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备" prop="devId">
              <j-dict-select-tag dictCode placeholder="请选择设备" type="list" v-model="model.devId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检类型" prop="patrolType">
              <j-dict-select-tag dictCode placeholder="请选择巡检类型" type="list" v-model="model.patrolType" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检项" prop="stlId">
              <j-dict-select-tag dictCode placeholder="请选择巡检项" type="list" v-model="model.stlId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检结果" prop="patrolResult">
              <j-dict-select-tag dictCode placeholder="请选择巡检结果" type="list" v-model="model.patrolResult" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'YwArtificialPatrolTaskDetailForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          taskId: [{ required: true, message: '请输入巡检任务!' }]
        },
        url: {
          add: '/device/patrol/ywArtificialPatrolTaskDetail/add',
          edit: '/device/patrol/ywArtificialPatrolTaskDetail/edit',
          queryById: '/device/patrol/ywArtificialPatrolTaskDetail/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      //   add () {
      //     this.edit(this.modelDefault);
      //   },
      //   edit (record) {
      //     this.model = Object.assign({}, record);
      //     this.visible = true;
      //   },
      show (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      }
    }
  }
</script>
